// Mirrors the contract of ruuts-api's replaceSpecialChars, which every KML import runs over each
// feature name before persisting it. Applying it at STAGE time is what keeps the panel honest: the
// name the operator reviews, edits and sees reported back is the exact name the backend stores, so
// the import summary cannot report a created lote as an auto-skipped duplicate, and the in-batch
// duplicate check predicts the backend's own rejection instead of diverging from it. This is a
// deliberate duplication of a backend rule and will drift the day that rule changes — hence this
// comment, and the tests pinning the exact behaviour.
const BRACKETED_SEGMENT = /\[[^\]]*\]/g

// ASCII on purpose, exactly like the backend's /[^\w\s]/g: ñ and accented vowels ARE stripped.
// Historical paddock names are stored accent-stripped and nothing migrates them, so a
// Unicode-preserving mirror would stage names the backend never persists and break the
// duplicate/skip prediction this normalizer exists for.
const UNSUPPORTED_CHARS = /[^\w\s]/g

// Whitespace is deliberately left alone: the rename input runs this on every keystroke, and
// trimming there would make a name containing a space impossible to type.
export const stripUnsupportedPaddockNameChars = (name: string): string =>
  name.replace(BRACKETED_SEGMENT, '').replace(UNSUPPORTED_CHARS, '')

// Both ends are trimmed, not just the end the backend trims: the confirm upload trims before
// serializing the KML, so a leading space would survive in the panel and vanish on persist —
// exactly the divergence this normalizer exists to remove.
export const normalizePaddockName = (name: string): string =>
  stripUnsupportedPaddockNameChars(name).trim()
